import styles from './EventList.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { EventCardProps, UI_EventCard } from 'ui/components/2-molecules/Card/EventCard/EventCard';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import IconArrow from 'ui/icons/icon_right_arrow.svg';

export interface EventListProps {
	heading: string;
	link?: { url: string; target?: string; name: string };
	items: EventCardProps[];
}
export const UI_EventList = ({ heading, link, items }: EventListProps) => {
	return (
		<div className={styles.EventList}>
			<UI_Heading className={styles.EventList_heading} headingLevel="h2" style="lg50">
				{heading}
			</UI_Heading>
			{link?.url && (
				<UI_LinkWithIcon
					className={styles.EventList_link}
					url={link.url}
					target={link.target}
					icon={
						<span className={styles.EventList_linkIcon}>
							<IconArrow />
						</span>
					}
					text={link.name}
				/>
			)}
			<div className={styles.EventList_items}>
				{items?.map((item, index) => <UI_EventCard className={styles.EventList_card} key={index} {...item} />)}
			</div>
		</div>
	);
};
